import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchBusinessCategory } from '../../redux/slice/businessCategory';
import NoData from '../../Component/NoData';
import placeImage from '../../images/placeholder.jpg';
import product from '../../images/Icons/product-icon.png';

export default function BusinessCategory() {
    const imageOnError = (event) => {
        event.currentTarget.src = placeImage;
    };

    const dispatch = useDispatch();
    const { businessCategoryData, isLoading, isError } = useSelector(
        (state) => state.businessCategory
    );

    useEffect(() => {
        if (!isError) {
            dispatch(fetchBusinessCategory());
        }
    }, [dispatch, isError]);

    // Filter categories with total_products > 0
    const validCategories = businessCategoryData?.filter(
        category => category.total_products > 0
    ) || [];

    // Only show if there are more than 1 categories with products
    if (isLoading) {
        return (
            <div className="container-fluid">
                <div className="showcase-product mrty1">
                    <div className="text-center py-4">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <p className="mt-2">Loading categories...</p>
                    </div>
                </div>
            </div>
        );
    }

    if (isError || validCategories.length <= 1) {
        return null; // Don't show anything on error or if 1 or fewer categories
    }

    return (
        <div className="container-fluid">
            <div className="showcase-product mrty1">
                <div className="row-hd-txt">
                    <div className="row-hd-txt-left">
                        <img src={product} alt="icon" />
                        <h5>Business Categories</h5>
                    </div>
                </div>

                {validCategories.length > 0 ? (
                    <div className="row shwc-pd-row">
                        {validCategories.map((category) => (
                            <div key={category.id} className="col-lg-3 col-md-4 col-6 px-2">
                                <Link to={`/business-category/${category.id}`} className="shwc-pd-dt">
                                    <figure>
                                        <img
                                            src={category.banner || category.thumbnail}
                                            onError={imageOnError}
                                            alt={category.name}
                                        />
                                    </figure>
                                    <span className="fw-500 text-uppercase">{category.name}</span>
                                    {/* <small className="product-count d-block mb-2">{category.total_products} Products</small> */}
                                    <button className="quote-btn">Explore Now</button>
                                </Link>
                            </div>
                        ))}
                    </div>
                ) : (
                    <NoData />
                )}
            </div>
        </div>
    );
}